import { ArticleParagraph1, ArticleParagraph3 } from '@cian/ui-kit';
import { IconProductSpecialLoanRate24, IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './bankListItem.css';
import { Link } from '../Link';
import { IPromoBank } from '../../types/newbuilding/promoInfo';

interface IBankListItemProps {
  bank: IPromoBank;
  label?: string;
  onClick?(): void;
}

export function BankListItem({ bank, label, onClick }: IBankListItemProps) {
  const { name, cianMortgagePartnerLink, secondSquareImageUrl, logoUrl } = bank;
  const bankLogo = secondSquareImageUrl || logoUrl;

  const isCianMortgagePartner = cianMortgagePartnerLink && cianMortgagePartnerLink.length > 0;

  return (
    <div className={styles['item']}>
      <div className={styles['logo']}>
        {bankLogo ? (
          <img className={styles['logo-img']} src={bankLogo} alt={name} />
        ) : (
          <div className={styles['logo-placeholder']}>
            <IconProductSpecialLoanRate24 color={'gray60_100'} />
          </div>
        )}
      </div>
      <div className={styles['content']}>
        {label && <ArticleParagraph3 color={'gray60_100'}>{label}</ArticleParagraph3>}
        <ArticleParagraph1>{name}</ArticleParagraph1>
        {isCianMortgagePartner && <ArticleParagraph3 color={'black_60'}>Банк-партнер Циан.Ипотека</ArticleParagraph3>}
      </div>
      {isCianMortgagePartner && (
        <div className={styles['icon-out']}>
          {cianMortgagePartnerLink && (
            <Link url={cianMortgagePartnerLink} target={'_blank'} onClick={onClick}>
              <IconActionArrowUpRight16 color={'icon-main-default'} />
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
